var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsSignOutNoArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 15,
    viewBox: "0 0 5 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1797 -35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,0H1A0,0,0,0,1,1,0V15a0,0,0,0,1,0,0H1a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0Z",
    transform: "translate(1797 35)",
    fill: "#3a3630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H3.5A.5.5,0,0,1,4,.5v0a.5.5,0,0,1-.5.5H0A0,0,0,0,1,0,1V0A0,0,0,0,1,0,0Z",
    transform: "translate(1798 49)",
    fill: "#3a3630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H3.5A.5.5,0,0,1,4,.5v0a.5.5,0,0,1-.5.5H0A0,0,0,0,1,0,1V0A0,0,0,0,1,0,0Z",
    transform: "translate(1798 35)",
    fill: "#3a3630"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSignOutNoArrow);
export default __webpack_public_path__ + "static/media/icons_SignOutNoArrow.d63bce3b5f15f15b118ea41f774bf020.svg";
export { ForwardRef as ReactComponent };